export function getBitmapPixelColor(
  view: DataView,
  xFrac: number,
  yFrac: number
): string | null {
  // BITMAPFILEHEADER
  const bfType = String.fromCharCode(view.getUint8(0), view.getUint8(1));
  if (bfType !== "BM") throw new Error("Invalid BMP signature: " + bfType);
  const bfOffBits = view.getUint32(10, true);

  // BITMAPINFOHEADER
  const biWidth = view.getInt32(18, true);
  const biHeight = view.getInt32(22, true);
  const biPlanes = view.getUint16(26, true);
  const biBitCount = view.getUint16(28, true);
  const biCompression = view.getUint32(30, true);

  if (biPlanes !== 1) throw new Error("Unsupported planes: " + biPlanes);
  if (![24, 32].includes(biBitCount))
    throw new Error("Unsupported bit count: " + biBitCount);
  if (biCompression !== 0)
    throw new Error("Unsupported compression: " + biCompression);

  // some BMP files store height as negative (when image is top-to-bottom)
  // by default (positive height), they're bottom-to-top
  const actualHeight = Math.abs(biHeight);
  const x = Math.floor(biWidth * xFrac);
  const y = Math.floor(actualHeight * yFrac);
  if (x < 0 || x >= biWidth || y < 0 || y >= actualHeight) return null;

  const pixelX = x;
  const pixelY = biHeight > 0 ? actualHeight - 1 - y : y;

  const pixelByteCount = biBitCount / 8;
  const rowByteCount = biWidth * pixelByteCount;
  const padding = (4 - (rowByteCount % 4)) % 4;
  const rowSize = rowByteCount + padding;

  // pixel position in buffer
  const pixelOffset = bfOffBits + pixelY * rowSize + pixelX * pixelByteCount;

  // BMP stores pixels as BGRA
  const blue = view.getUint8(pixelOffset);
  const green = view.getUint8(pixelOffset + 1);
  const red = view.getUint8(pixelOffset + 2);
  //const alpha = biBitCount === 32 ? view.getUint8(pixelOffset + 3) : 255;

  // 0xRRGGBB
  const col = (red << 16) | (green << 8) | blue;
  return "#" + col.toString(16).padStart(6, "0").toUpperCase();
}
